import { Typography } from "@mui/material";
import CustomConfirmDialog from "../../../core/components/common/custom-confirm-dialog.component";
import { useState } from "react";
import CustomLoader from "../../../core/components/common/custom-loader.component";
import { useSnackbar } from 'notistack';
import RoleManagementService from "../services/api/role-managment-service";

const ActiveRole = ({row, open, setOpen, handleRecordChange}) => {

    const { enqueueSnackbar } = useSnackbar();
    const [loading, setLoading] = useState(false);

    const handleClose = () => setOpen(false);
    const handleConfirm = () => {
        setLoading(true);

        let parameters = {
            'active': '1',
            'id': row.id
        }

        RoleManagementService.updateRoleStatus(parameters).then((res) => {
            setLoading(false);
            setOpen(false)
            handleRecordChange()
            enqueueSnackbar("Role was successfully deactivated", {
                variant: "success",
                autoHideDuration: 1500
            })
        }).catch((error) => {
            setLoading(false);
            const errorMessage = error?.response?.data?.error || error.message;
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 2000
            })
        })
    }
    
    return (
        <CustomConfirmDialog
        loading={loading}
        open={open}
        handleClose={handleClose}
        handleConfirm={handleConfirm} 
        title={'Activate Role'}
        >
        <div>
            {loading ? (
                <CustomLoader />
            ):(
                <Typography>Are you sure you want to activate this role?</Typography>
            )}
        </div>
      
        </CustomConfirmDialog>
    )
}

export default ActiveRole